import { render, staticRenderFns } from "./GroupABMComponent.vue?vue&type=template&id=f2ecd30c&scoped=true"
import script from "./GroupABMComponent.js?vue&type=script&lang=js&external"
export * from "./GroupABMComponent.js?vue&type=script&lang=js&external"
import style0 from "./GroupABMComponent.vue?vue&type=style&index=0&id=f2ecd30c&prod&scoped=true&lang=scss"
import style1 from "./GroupABMComponent.vue?vue&type=style&index=1&id=f2ecd30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ecd30c",
  null
  
)

export default component.exports